/** The height of the part of the window that can be seen, for placing menus. On an iPhone, Safari's toolbar can cover the
 * bottom of the window: `innerHeight` counts the space behind it, while the root element's height and the visual viewport
 * don't. */
export function visibleHeight(): number {
  const viewport = window.visualViewport;
  return Math.min(window.innerHeight, document.documentElement.clientHeight || window.innerHeight, viewport ? viewport.offsetTop + viewport.height : Infinity);
}
